module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": _vm.uniqid
    }
  }, [_c('input', {
    ref: "file",
    attrs: {
      "type": "file",
      "id": _vm.uniqid,
      "name": "fileUpload"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bb46fcd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Uploader.vue
// module id = 363
// module chunks = 9